
import { Component, Prop, Vue } from "vue-property-decorator";
import {
  TemplateCreate,
  TemplateNew,
  TemplateUpdate
} from "@/lib/model/template/template-new";
import { ElForm } from "element-ui/types/form";
import Pop from "../../ai-builder/components/blue-pop.vue";

import _ from "lodash-es";
@Component({ components: { Pop } })
export default class MessageDialog extends Vue {
  @Prop({}) exam!: any;
  @Prop({}) onlyShow!: boolean;
  @Prop({}) tId!: number;
  title = "新建短信通知模板";
  template = new TemplateNew();
  content = "";
  rules = {
    name: [{ required: true, message: "请输入名称", trigger: "change" }],
    env: [{ required: true, message: "请选择", trigger: "change" }],
    mobileContent: [
      { required: true, message: "请输入模板内容", trigger: "change" }
    ]
  };
  tagList = [
    { name: "{候选人姓名}" },
    { name: "{公司名称}" },
    { name: "{面试名称}" },
    { name: "{面试链接}" },
    { name: "{面试有效期}" },
    { name: "{定向邀请链接有效期}" },
    { name: "{答题时间限制}" }
  ];
  tagListJob = [
    { name: "{候选人姓名}" },
    { name: "{公司名称}" },
    { name: "{职位组展示标题}" },
    { name: "{职位组链接}" }
  ];
  get tagListFilter() {
    const env = this.template.env;
    return env === 20
      ? this.tagListJob
      : env >= 2 && env <= 4
      ? [...this.tagList, { name: "{面试结果链接}" }]
      : this.tagList;
  }

  created() {
    this.template.type = 1;
    if (this.tId) {
      //编辑
      TemplateNew.getDetail(this.tId).then(res => {
        if (res.code === 0) {
          this.template = new TemplateNew().assign(res.data);
        }
      });
      this.title = this.onlyShow ? "查看短信通知模板" : "编辑短信通知模板";
    } else {
      //新建
    }
  }
  mounted() {
    //
  }
  addTag(it: any) {
    if (this.onlyShow) return false;
    const insertTxt = it.name;
    const elInput: any = document.getElementById("input");
    // 获取光标所在位置前后字符串的索引
    const startPos = elInput?.selectionStart;
    const endPos = elInput?.selectionEnd;

    if (startPos === undefined || endPos === undefined) return;
    const txt = elInput?.value;
    const result =
      txt.substring(0, startPos) + insertTxt + txt.substring(endPos);
    //form.setFieldsValue({ [`${focus}`]: result }); // 输入框为表单元素时需要添加
    console.log(result);
    elInput.value = result;
    elInput.focus();
    // 确定光标位置
    elInput.selectionStart = startPos + insertTxt.length;
    elInput.selectionEnd = endPos + insertTxt.length;
    this.template.mobileContent = result;
  }
  templateEnvChange(value: any) {
    // 职位组切换更改富文本
    let list = this.template.mobileContent.split("{");
    if (value === 20 && this.template.mobileContent) {
      list = list.map(el => {
        el = el
          .replace("面试名称}", "")
          .replace("面试链接}", "")
          .replace("面试有效期}", "")
          .replace("定向邀请链接有效期}", "")
          .replace("答题时间限制}", "")
          .replace("面试结果链接}", "");
        if (el.indexOf("}") > -1) {
          el = "{" + el;
        }
        return el;
      });
      // this.template.mobileContent = list.join("");
    } else if (value >= 2 && value <= 4) {
      list = list.map(el => {
        el = el.replace("职位组链接}", "").replace("职位组展示标题}", "");
        if (el.indexOf("}") > -1) {
          el = "{" + el;
        }
        return el;
      });
    } else {
      list = list.map(el => {
        el = el
          .replace("职位组链接}", "")
          .replace("职位组展示标题}", "")
          .replace("面试结果链接}", "");
        if (el.indexOf("}") > -1) {
          el = "{" + el;
        }
        return el;
      });
    }
    this.template.mobileContent = list.join("");
  }
  ok() {
    (this.$refs.form as ElForm).validate(res => {
      if (res) {
        if (this.tId) {
          const template = new TemplateUpdate().assign(this.template);
          TemplateNew.update(template).then(res => {
            if (res.code === 0) {
              this.$emit("ok");
            }
          });
        } else {
          const template = new TemplateCreate().assign(this.template);
          TemplateNew.create(template).then(res => {
            if (res.code === 0) {
              this.$emit("ok");
            }
          });
        }
      }
    });
  }

  //关闭
  close() {
    this.$emit("cancelMessage", false);
  }
}
